import * as React from 'react';
import dynamic from 'next/dynamic';
import { UseDocumentationModalsResult } from '@/interfaces';
import { ModalFollowUp } from '../ModalFollowUp';
import { ModalAcceptOptOut } from '../ModalAcceptOptOut';
import { ModalReviewSign } from '../modal-review-sign/ModalReviewSign';
import { ModalReviewSignLawyer } from '../modal-review-sign/ModalReviewSignLawyer';
import { ModalReviewRetainer } from '../modal-sign-retainer/ModalReviewRetainer';
import { ModalFollowUpAnswers } from '../follow-up/ModalFollowUpAnswers';

const ClaimFromModal = dynamic(
	() => import('@/components/modals/ClaimFormModal'),
	{ ssr: false }
);

interface DocumentationModalsProps {
	modals: UseDocumentationModalsResult;
	caseName?: string;
	applicationId?: number;
	uploadButton: boolean;
	clientFirstname?: string;
	clientLastname?: string;
	isClientView: boolean;
	refetch: () => void;
}

export const DocumentationModals: React.FC<DocumentationModalsProps> = ({
	modals,
	caseName,
	applicationId,
	uploadButton,
	clientFirstname,
	clientLastname,
	isClientView,
	refetch,
}) => {
	const {
		documentationSelected,
		isClaimFormOpen,
		setIsClaimFormOpen,
		isModalFollowUpOpen,
		setIsModalFollowUpOpen,
		isModalAcceptOpt,
		setIsModalAcceptOpt,
		isModalReviewSignOpen,
		setIsModalReviewSignOpen,
		isModalRetainerOpen,
		setIsModalRetainerOpen,
		isModalFollowSurveyOpen,
		setIsModalFollowSurveyOpen,
		isDocumentReviewSign,
		documentStatus,
	} = modals;

	return (
		<>
			{documentationSelected && isClaimFormOpen && (
				<ClaimFromModal
					isReadOnly={!uploadButton}
					caseName={caseName ?? ''}
					isOpen={isClaimFormOpen}
					selectedClaim={documentationSelected}
					clientFirstname={clientFirstname}
					clientLastname={clientLastname}
					onClose={() => setIsClaimFormOpen(false)}
				/>
			)}
			{documentationSelected && isModalFollowUpOpen && (
				<ModalFollowUp
					actionRequiredId={documentationSelected.action_id}
					isOpen={isModalFollowUpOpen}
					setIsModalOpen={setIsModalFollowUpOpen}
					isFollowUpResponsed
					modalTitle={documentationSelected.file_name}
				/>
			)}
			{documentationSelected && applicationId && isModalAcceptOpt && (
				<ModalAcceptOptOut
					applicationId={applicationId || 0}
					actionReqId={documentationSelected.action_id}
					caseName={''}
					isOpen={isModalAcceptOpt}
					setIsModalOpen={setIsModalAcceptOpt}
					url={documentationSelected?.file_path || ''}
					isAccepted
				/>
			)}

			{isModalReviewSignOpen &&
				documentationSelected &&
				(!!isDocumentReviewSign && !documentStatus.isApproved ? (
					<ModalReviewSign
						isOpen={isModalReviewSignOpen}
						setIsModalOpen={setIsModalReviewSignOpen}
						actionRequiredId={documentStatus.actionId}
						applicationId={applicationId}
						urlDoc={documentationSelected.url_doc}
						wasPreviouslyDeclined
						refetch={refetch}
					/>
				) : (
					<ModalReviewSignLawyer
						isOpen={isModalReviewSignOpen}
						setIsModalOpen={setIsModalReviewSignOpen}
						actionRequiredId={documentStatus.actionId}
						urlDoc={documentationSelected.url_doc}
						isClientView={isClientView}
					/>
				))}
			{isModalRetainerOpen && (
				<ModalReviewRetainer
					isOpen={isModalRetainerOpen}
					setIsModalOpen={setIsModalRetainerOpen}
					actionRequiredId={documentationSelected?.action_id}
				/>
			)}

			{isModalFollowSurveyOpen && documentationSelected && (
				<ModalFollowUpAnswers
					data={documentationSelected}
					isOpen={isModalFollowSurveyOpen}
					setIsModalOpen={() => setIsModalFollowSurveyOpen(false)}
				/>
			)}
		</>
	);
};
